<template>
  <div
    class="max-h-screen mx-auto overflow-auto transition ease-in-out duration-side-menu-transition-duration bg-light-screen-background dark:bg-dark-screen-background">
    <!-- <div class="flex items-center justify-center h-screen text-center" :class="{ hidden: s, 'lg:hidden': !s }">
      <p class="text-xl text-gray-700 dark:text-gray-300">
        Sorry, our website is not available for smaller devices. Please view on a larger screen.
      </p>
    </div> -->

    <!-- Main content for larger screens, always visible if screen is true -->
    <div class="block">
      <router-view v-slot="{ Component }">
        <component :is="Component" :style="cssVars" />
      </router-view>

      <!-- Global spinner -->
      <div v-show="$store.state.ui?.showLoading">
        <LoadingComponent />
      </div>

      <!-- Global components  -->
      <Notifications />

      <!-- Notification container -->
      <div
        id="notification-container"
        class="flex items-end justify-center h-auto text-center sm:block sm:p-0 absolute -translate-x-2/4 -translate-y-2/4 w-full z-40 py-2.5 left-2/4 top-2/4" />
    </div>
  </div>
</template>

<script>
import Notifications from "@/components/shared/Notifications.vue"
import LoadingComponent from "@/components/shared/LoadingComponent.vue"
import { utils } from "./store/helpers"
import store from "./store"
export default {
  name: "App",
  components: {
    Notifications,
    LoadingComponent
  },
  provide() {
    return {
      getModule(reference_code) {
        reference_code = reference_code.startsWith("rs-") ? reference_code : `rs-${reference_code}`
        return utils.find(store.state.control.modules, { reference_code: reference_code })
      },
      isModuleActivated(reference_code) {
        reference_code = reference_code.startsWith("rs-") ? reference_code : `rs-${reference_code}`
        return utils.filter(store.state.control.modules, { reference_code: reference_code, is_activated: true }).length > 0
      },
      isModuleVisible(reference_code) {
        reference_code = reference_code.startsWith("rs-") ? reference_code : `rs-${reference_code}`
        return utils.filter(store.state.control.modules, { reference_code: reference_code, is_visible: true }).length > 0
      },
      isModuleReady(reference_code) {
        reference_code = reference_code.startsWith("rs-") ? reference_code : `rs-${reference_code}`

        if (utils.filter(store.state.settings.modules_settings, { module_reference_code: reference_code, is_required: true }).length > 0) {
          return utils
            .filter(store.state.settings.modules_settings, { module_reference_code: reference_code, is_required: true })
            .reduce((status, setting) => {
              if (setting.type == "object_selection" && utils.isEmpty(setting.selected_object)) {
                return false
              } else if (setting.type == "metric_selection" && utils.isEmpty(setting.selected_metric)) {
                return false
              } else if (setting.type == "option_selection" && utils.isEmpty(setting.selected_metric)) {
                return false
              } else if (setting.type == "multiple_object_metric_mappings" && setting?.mapped_objects_metrics.length == 0) {
                return false
              } else if (setting.type == "forecasting_mappings" && setting?.forecasting_mappings.length == 0) {
                return false
              } else {
                return status
              }
            }, true)
        }
        return true
      }
    }
  },

  computed: {
    cssVars() {
      return {
        "--circles-bg-color": this.isDarkMode ? "#2B3C44" : "#FFFFFF",
        "--lines-color": this.isDarkMode ? "#49606D" : "#B3CAD6"
      }
    },
    isDarkMode() {
      if (store.state.ui.darkMode) {
        document.documentElement.classList.add("dark")
      } else {
        document.documentElement.classList.remove("dark")
      }
      return store.state.ui.darkMode
    }
  },
  mounted() {
    const darkMode = window.localStorage.getItem("dark-mode")?.toLowerCase() === "true"
    if (darkMode) {
      document.documentElement.classList.add("dark")
    }
  }
}
</script>

<style lang="scss">
* {
  scroll-behavior: smooth;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.6s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.no-scrollbar::-webkit-scrollbar {
  display: none;
}

.transparent-scrollbar::-webkit-scrollbar {
  opacity: 0;
}

.no-scrollbar {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.tooltip {
  display: block !important;
  z-index: 10000;
}

.tooltip .tooltip-inner {
  background: black;
  color: white;
  border-radius: 16px;
  padding: 5px 10px 4px;
}

.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: black;
  z-index: 1;
}

.tooltip[x-placement^="top"] {
  margin-bottom: 5px;
}

.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}

.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="right"] {
  margin-left: 5px;
}

.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip[x-placement^="left"] {
  margin-right: 5px;
}

.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip.popover .popover-inner {
  background: #f9f9f9;
  color: black;
  padding: 24px;
  border-radius: 5px;
  box-shadow: 0 5px 30px rgba(black, 0.1);
}

.tooltip.popover .popover-arrow {
  border-color: #f9f9f9;
}

.tooltip[aria-hidden="true"] {
  visibility: hidden;
  opacity: 0;
  transition:
    opacity 0.15s,
    visibility 0.15s;
}

.tooltip[aria-hidden="false"] {
  visibility: visible;
  opacity: 1;
  transition: opacity 0.15s;
}
.organization-tree-node-btn {
  position: absolute;
  top: 100%;
  left: 50%;
  width: 20px;
  height: 20px;
  z-index: 10;
  margin-left: -11px;
  margin-top: 9px;
  background-color: var(--circles-bg-color);
  border: 1px solid var(--lines-color);
  border-radius: 50%;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  -webkit-transition: all 0.35s ease;
  transition: all 0.35s ease;
}

.organization-tree-node:after {
  border-left: 1px solid var(--lines-color);
}
.organization-tree-node:not(:first-child):before,
.organization-tree-node:not(:last-child):after {
  border-top: 1px solid var(--lines-color);
}

.ql-snow .ql-tooltip {
  transform: translateX(110px) !important;
  z-index: 100 !important;
}

.ql-toolbar.ql-snow {
  border-top-left-radius: 7px !important;
  border-top-right-radius: 7px !important;
}

.apexcharts-title-text {
  display: none !important;
}
</style>
